import { NON_CORE_SECTION_SCORES_MAP } from "../config";
import { ResumeAnalysis } from "../resume-analysis/resume-analyse-types";
import { getStatementScore } from "../statment-analysis-scoring";



export const getAwardsScore = (awards: ResumeAnalysis["awards"], maxScoreOfSection: number): {
  totalScore: number;
  titleScore: number;
  issuerScore: number;
  descriptionScore: number;
} => {
  const numberOfAwards = awards?.individualAwardsAnalysis?.length;
  const scorePerAward = maxScoreOfSection / numberOfAwards;

  if (numberOfAwards === 0) return {
    totalScore: 0,
    titleScore: 0,
    issuerScore: 0,
    descriptionScore: 0
  };
  let titleScore = 0;
  let issuerScore = 0;
  let descriptionScore = 0;

  awards.individualAwardsAnalysis?.forEach((award) => {
    if (award.award) {
      titleScore += scorePerAward * NON_CORE_SECTION_SCORES_MAP.awards.title;
    }
    if (award.issuer) {
      issuerScore += scorePerAward * NON_CORE_SECTION_SCORES_MAP.awards.issuingOrganization;
    }
    if (award.descriptionAnalysis.length > 0) {
      const numberOfDescriptions = award.descriptionAnalysis.length;
      const scorePerDescription = scorePerAward * NON_CORE_SECTION_SCORES_MAP.awards.statementWeight / numberOfDescriptions;
      descriptionScore = 0;
      award.descriptionAnalysis.forEach((description) => {
        const descriptionScoreResult = getStatementScore(description.analysis, scorePerDescription);
        descriptionScore += descriptionScoreResult.totalScore;
      });
      descriptionScore = Math.min(descriptionScore, scorePerAward * NON_CORE_SECTION_SCORES_MAP.awards.statementWeight);
    }
  });

  return {
    totalScore: titleScore + issuerScore + descriptionScore,
    titleScore,
    issuerScore,
    descriptionScore
  };

}
